var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11048",
    "data-name": "Rectangle 11048",
    width: 20,
    height: 20,
    fill: "#8d99ae",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4538",
    "data-name": "Path 4538",
    d: "M6.978,7.8a6.6,6.6,0,0,0,2.47,2.47L10,9.5a.625.625,0,0,1,.808-.185,7.138,7.138,0,0,0,2.865.852.625.625,0,0,1,.576.623v2.789a.625.625,0,0,1-.561.622,9.786,9.786,0,0,1-1,.051A9.688,9.688,0,0,1,3,4.563a9.792,9.792,0,0,1,.051-1A.625.625,0,0,1,3.673,3H6.462a.625.625,0,0,1,.623.576A7.138,7.138,0,0,0,7.938,6.44a.625.625,0,0,1-.185.808ZM5.4,7.391,6.59,6.543A8.381,8.381,0,0,1,5.9,4.25H4.256q-.006.156-.006.313A8.438,8.438,0,0,0,12.688,13q.157,0,.313-.006V11.345a8.382,8.382,0,0,1-2.293-.686l-.848,1.188a7.781,7.781,0,0,1-.992-.469l-.036-.021A7.847,7.847,0,0,1,5.892,8.419l-.021-.036A7.776,7.776,0,0,1,5.4,7.391Z",
    transform: "translate(1.375 1.375)",
    fill: "#8d99ae"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1761d9f2f9d161ef2a3b4044fbd3a706.svg";
export { ForwardRef as ReactComponent };